<template>
    <component :is="this.$route.meta.layout || 'div'">
      <router-view></router-view>
      <notifications position="bottom right"/>
    </component>
</template>

<style lang="scss">
</style>
